class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
  }

  renderContents(parsedState) {
    const defaultEl = document.getElementById("cart-notification-default");
    if (defaultEl) {
      defaultEl.innerHTML = "";
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const targetEl = document.getElementById(section.id);

      if (!targetEl) {
        console.warn(`[cart-notification] Section "${section.id}" not found in DOM — skipping.`);
        return;
      }

      const html = parsedState.sections[section.id];
      if (!html) {
        console.warn(`[cart-notification] No section data returned for "${section.id}" — skipping.`);
        return;
      }

      const innerHTML = this.getSectionInnerHTML(html, section.selector);
      if (innerHTML === null) {
        console.warn(`[cart-notification] Selector "${section.selector || '.shopify-section'}" not found for "${section.id}" — skipping.`);
        return;
      }

      targetEl.innerHTML = innerHTML;
    });

    const dropDownIcon = document.querySelector('#cart-icon-bubble');
    if (dropDownIcon && dropDownIcon.getAttribute("aria-expanded") === "false") {
      dropDownIcon.click();
    }
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-product' },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
      { id: 'cart-upsell' },
      { id: 'cart-drawer-gift' }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedEl = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);

    return parsedEl ? parsedEl.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);